import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider, Typography,
} from "@mui/material";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";

interface ConfirmImportDialogProps {
  open: boolean;
  totalRows: number;
  dataLength: number;
  onConfirm: () => void;
  onCancel: () => void;
  csvFile?: string;
}

const ConfirmImportDialog: React.FC<ConfirmImportDialogProps> = ({
  open,
  onConfirm,
  onCancel,
  dataLength, totalRows,
  csvFile
}) => {
  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {onCancel();
      }}
      // maxWidth="xs"
      fullWidth={true}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Importing {csvFile}
      </DialogTitle>
      <DialogContent dividers={true}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          width="100%"
          padding={2}
        >
          <Typography>

            <strong> {dataLength} record{dataLength > 1 ? 's' : ''}</strong> will be processed
            <br/>
            <br/>
            Are you sure you want to import.
          </Typography>
        </Box>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button onClick={onCancel} variant="outlined">
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="contained" color="primary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmImportDialog;
